export default __webpack_public_path__ + "static/media/ind1.c4c05b51.jpg";